import { Component, Input, inject } from '@angular/core';
import { AuthService } from '../../../../auth/auth.service';
import { Team } from '../../../../_shared/models/team.model';
import { Tie } from '../../../../_shared/models/tie.model';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { InviteTeamOwnerComponent } from '../invite-team-owner/invite-team-owner.component';
import { SelectTieTeamComponent } from '../select-tie-team/select-tie-team.component';
import { TeamProfileImageComponent } from '../../../../_shared/components/team-profile-image/team-profile-image.component';

@Component({
  selector: 'app-team-logo',
  templateUrl: './team-logo.component.html',
  styleUrls: ['./team-logo.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    InviteTeamOwnerComponent,
    SelectTieTeamComponent,
    TeamProfileImageComponent
  ],
})
export class TeamLogoComponent {
  private authService = inject(AuthService);

  @Input() tie: Tie;
  @Input() team: Team;
  @Input() sideNumber: number;

  showInviteSelect(sideNumber: number): boolean {
    // auth User is tie or side owner
    const sideOwners = this.tie?.sides?.[sideNumber - 1]?.owners ?? [];
    return (
      this.tie?.owners?.includes(this.authService.authUserSignal()?._id) ||
      sideOwners.includes(this.authService.authUserSignal()?._id)
    );
  }
}
